module.exports = __webpack_public_path__ + "img/Group10@2x.693efabc.svg";